import React, { useState } from 'react';
import LocationCard from './LocationCard';
import { scrollToAnchor } from 'utils/scroll';

import * as styles from './DesktopContent.module.scss';

const SHOW_COUNTER_STEP = 4;

export default function DesktopContent({ items, blockId }) {
  const [showCounter, setShowCounter] = useState(SHOW_COUNTER_STEP);

  const seeMoreCounter = items.length - showCounter;
  const showMoreButton = showCounter < items.length;
  const showHideButton = showCounter > SHOW_COUNTER_STEP;

  const seeMoreHandler = () => {
    setShowCounter(prev => prev + SHOW_COUNTER_STEP);
  };

  const hideAllHandler = () => {
    setShowCounter(SHOW_COUNTER_STEP);
    scrollToAnchor(blockId);
  };

  return (
    <>
      <div className={styles.eventsWrapper}>
        {items.map((item, i) => (
          <LocationCard
            key={i}
            className={i >= showCounter ? styles.hidden : undefined}
            {...item}
          />
        ))}
      </div>
      {(showMoreButton || showHideButton) && (
        <div className={styles.buttonsRow}>
          {showMoreButton && (
            <button className={styles.seeMoreButton} onClick={seeMoreHandler}>
              See more ({seeMoreCounter})
            </button>
          )}
          {showHideButton && (
            <button className={styles.hideAllButton} onClick={hideAllHandler}>
              Hide all
            </button>
          )}
        </div>
      )}
    </>
  );
}
